import { makeStateKey } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable } from 'rxjs';
import { CacheRef, resolverSSGFirst } from './ssg-first.utils';
import type { PaginaEntry } from '@core/interfaces/modyo';

const STATE_KEY = makeStateKey<PaginaEntry>('pagina-encuesta-facilidad');
const cache: CacheRef<PaginaEntry> = { valor: null };

export const resetCacheEncuestaFacilidad = (): void => {
  cache.valor = null;
};

export const encuestaFacilidadResolver: ResolveFn<PaginaEntry | null> = (): Observable<PaginaEntry | null> =>
  resolverSSGFirst({
    stateKey: STATE_KEY,
    cache,
    rutaSsg: 'encuesta-facilidad',
    uidTipo: 'pagina',
    slug: 'paginaencuestafacilidad',
  });
